"use client";
import { PropsWithChildren } from "react";
import Header from "./sections/header/Header";
import Footer from "./sections/footer/Footer";

const BaseLayout = ({ children }: PropsWithChildren) => {
  return (
    <main>
      <Header />
      {children}
      <Footer />
    </main>
  );
};

export default BaseLayout;
